import {GetData, NewDataExists} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public GetData: GetData,
    public NewDataExists: NewDataExists,
  ) {}
}